import styled from 'styled-components';

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  background: #ffffff;
  object-fit: contain;
  object-position: center;
`;

export const ProductCard = styled.article`
  display: flex;
  width: min(100%, 420px);
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e3e6e8;
  flex-direction: column;
  background: #ffffff;
`;

export const ProductMediaFrame = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
`;

export const ProductCardPanel = styled.div`
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 178px;
  padding: 20px;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  background: #e9ecef;
`;

export const ProductOwnerAvatar = styled.img`
  position: absolute;
  top: 20px;
  display: block;
  width: 48px;
  height: 48px;
  border: 1px solid #ffffff;
  background: #e9ecef;
  object-fit: cover;
  transform: translateY(-100%);
`;

export const ProductCardName = styled.h3`
  display: -webkit-box;
  margin: 8px 0 0;
  overflow: hidden;
  color: #120e02;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const ProductCardDescription = styled.p`
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #495057;
  font-size: 13px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const ProductCardVariantControls = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
`;

export const ProductCardSize = styled.span`
  display: inline-flex;
  min-width: 64px;
  max-width: 112px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #868e96;
  align-items: center;
  overflow: hidden;
  background: #ffffff;
  color: #212529;
  font-size: 12px;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const ProductCardColor = styled.span`
  display: block;
  width: 24px;
  height: 24px;
  border: 2px solid #120e02;
  border-radius: 50%;
  flex: 0 0 24px;
  background: ${({ $color }) => $color};
  box-shadow: 0 0 0 1px #adb5bd;
`;

export const ProductCardActions = styled.div`
  display: flex;
  margin-top: auto;
  padding-top: 4px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ProductCardPrice = styled.p`
  margin: 0;
  color: #120e02;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
`;

export const BasketButton = styled.button`
  display: flex;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: #120e02;
  color: #ffffff;

  svg {
    width: 20px;
    height: 20px;
  }
`;
